document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(".wp-block-navigation__submenu-container");
  const isMobile = window.matchMedia("(max-width: 600px)").matches;

  function closeAllSubmenus() {
    menuItems.forEach((submenu) => {
      submenu.style.display = "none";
      const parentItem = submenu.closest(".wp-block-navigation-item");
      if (parentItem) {
        parentItem.classList.remove("active");
      }
    });
  }

  function openSubmenu(submenu) {
    submenu.style.display = "block";
    const parentItem = submenu.closest(".wp-block-navigation-item");
    if (parentItem) {
      parentItem.classList.add("active");
    }
  }

  function toggleSubmenu(submenu) {
    if (submenu.style.display === "block") {
      submenu.style.display = "none";
      submenu.closest(".wp-block-navigation-item").classList.remove("active");
    } else {
      openSubmenu(submenu);
    }
  }

  closeAllSubmenus();

  menuItems.forEach((submenu) => {
    const parentItem = submenu.closest(".wp-block-navigation-item");
    if (parentItem) {
      if (!isMobile) {
        parentItem.addEventListener("mouseenter", function () {
          openSubmenu(submenu);
        });
        parentItem.addEventListener("mouseleave", function () {
          closeAllSubmenus();
        });
      }

      parentItem.addEventListener("click", function (event) {
        const target = event.target;
        if (target.closest(".wp-block-navigation__submenu-container a")) {
          return;
        }

        event.preventDefault();
        toggleSubmenu(submenu);
      });
    }
  });
});

// add body class for scrolling
document.addEventListener("DOMContentLoaded", function () {
  function handleScroll() {
    if (window.scrollY > 100) {
      document.body.classList.add("is-scrolled");
    } else {
      document.body.classList.remove("is-scrolled");
    }
  }

  window.addEventListener("scroll", handleScroll);
});